import { updateTutor } from "../../../../api/endpoints/tutors/tutors";
import UserPersonalInfo from "../../../../components/personalInfo/UserPersonalInfo";
import { createBrowserHistory } from "history";
import { useAuth } from "../../../../context/AuthContext";

export default function ProfileInfo() {
  const userContext = useAuth();
  const history = createBrowserHistory();
  const afterSubmit = () => {
    history.go(0);
  };
  return (
    <div className="flex h-fit flex-col  items-center w-full">
      <UserPersonalInfo
        updateUser={updateTutor}
        user={userContext?.currentUser!}
        afterSubmit={afterSubmit}
        isEditable={true}
        stylesClass={"md:bg-white"}
        showTitle={false}
      />
    </div>
  );
}
